<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="loginModalLabel">Ricerca Azienda e Località</h5>
      </div>

      <form @submit.prevent="onSubmit">
        <div class="modal-body">
          <div v-if="isLoading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
          </div>

          <div v-else-if="!isLoggedIn" class="alert alert-danger">
            Devi effettuare il login per utilizzare questa funzionalità.
          </div>

          <div v-else>
            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>
            <div class="form-group">
              <label for="provincia">Provincia Azienda</label>
              <input
                type="text"
                id="provincia"
                v-model="localProvinciaAzienda"
                class="form-control"
                list="province-list"
                placeholder="Seleziona una provincia"
                @input="localComuneAzienda = ''"
              />
              <datalist id="province-list">
                <option v-for="provincia in province" :key="provincia.SiglaProvincia" :value="provincia.SiglaProvincia">
                  {{ provincia.Provincia }}
                </option>
              </datalist>
            </div>

            <div class="form-group">
              <label for="comune">Comune Azienda</label>
              <input
                type="text"
                id="comune"
                v-model="localComuneAzienda"
                class="form-control"
                list="comuni-list"
                placeholder="Seleziona un comune"
                :disabled="!localProvinciaAzienda"
              />
              <datalist id="comuni-list">
                <option
                  v-for="comune in comuniFiltrati"
                  :key="comune.CodiceIstat"
                  :value="comune.Comune"
                >
                  {{ comune.Comune }}
                </option>
              </datalist>
            </div>

            <div class="form-group">
              <label for="radius">Radius Azienda</label>
              <input type="number" id="radius" v-model="localRadiusAzienda" class="form-control" />
            </div>

            <div class="form-group">
              <label for="radius">Popolazione minima</label>
              <input type="number" id="popolazioneMinima" v-model="localPopolazioneMinima" class="form-control" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" :disabled="isLoading || !isLoggedIn">Cerca</button>
          <button type="button" class="btn btn-secondary" @click="closeModal" :disabled="isLoading">Chiudi</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore';

export default {
  name: 'ModalRicerca',
  props: {
    show: Boolean,
    comuneAzienda: String,
    provinciaAzienda: String,
    radiusAzienda: Number,
    popolazioneMinima: Number,
    cercaAzienda: Function,
  },
  data() {
    return {
      localComuneAzienda: this.comuneAzienda,
      localProvinciaAzienda: this.provinciaAzienda,
      localRadiusAzienda: this.radiusAzienda,
      localPopolazioneMinima: this.popolazioneMinima,
      isLoading: false, // Stato di caricamento
      errorMessage: "", // Messaggio di errore
    };
  },
  computed: {
    isLoggedIn() {
      const authStore = useAuthStore();
      return authStore.isLoggedIn;
    },
    province() {
      const authStore = useAuthStore();
      return authStore.user?.listaProvince || [];
    },
    comuniFiltrati() {
      const authStore = useAuthStore();
      if (!this.localProvinciaAzienda) {
        return []; // Nessuna provincia selezionata, restituisci un array vuoto
      }
      return authStore.user?.listaComuni?.filter(
        (comune) => comune.SiglaProvincia === this.localProvinciaAzienda
      ) || [];
    },
  },
  methods: {
    closeModal() {
      this.errorMessage = ""; // Resetta il messaggio di errore
      this.$emit("update:show", false); // Chiude la modale
    },
    async onSubmit() {
      if (!this.isLoggedIn) {
        this.errorMessage = "Devi effettuare il login per eseguire la ricerca.";
        return;
      }

      if (!this.localProvinciaAzienda || !this.localComuneAzienda) {
        this.errorMessage = "Provincia e Comune sono obbligatori.";
        return;
      }

      if (!this.localRadiusAzienda || this.localRadiusAzienda <= 0) {
        this.errorMessage = "Il raggio deve essere un numero positivo.";
        return;
      }

      if (this.localPopolazioneMinima < 0) {
        this.errorMessage = "La popolazione minima non può essere negativa.";
        return;
      }

      try {
        // Emette i valori aggiornati al parent
        this.$emit("update:comuneAzienda", this.localComuneAzienda);
        this.$emit("update:provinciaAzienda", this.localProvinciaAzienda);
        this.$emit("update:radiusAzienda", this.localRadiusAzienda);
        this.$emit("update:popolazioneMinima", this.localPopolazioneMinima);

        // Chiama la funzione di ricerca passata come prop
        this.errorMessage = "";
        await this.cercaAzienda();

        // Resetta il messaggio di errore e chiude la modale
//        this.errorMessage = "";
//        this.closeModal();
      } catch (error) {
        // Mostra il messaggio di errore nella modale
        this.errorMessage = error.message || "Si è verificato un problema durante la ricerca.";
        console.error("Errore durante la ricerca:", error);
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1010;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 500px;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
